// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1StorageClassParameters } from './V1StorageClassParameters';
import {
  V1StorageClassParametersFromJSON,
  V1StorageClassParametersFromJSONTyped,
  V1StorageClassParametersToJSON,
  V1StorageClassParametersToJSONTyped,
} from './V1StorageClassParameters';

/**
 *
 * @export
 * @interface TypesAppliedSettings
 */
export interface TypesAppliedSettings {
  /**
   *
   * @type {V1StorageClassParameters}
   * @memberof TypesAppliedSettings
   */
  diskParameters?: V1StorageClassParameters;
  /**
   *
   * @type {number}
   * @memberof TypesAppliedSettings
   */
  diskSize?: number;
  /**
   *
   * @type {string}
   * @memberof TypesAppliedSettings
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof TypesAppliedSettings
   */
  neo4jConfiguration?: string;
  /**
   *
   * @type {string}
   * @memberof TypesAppliedSettings
   */
  neo4jVersion?: string;
  /**
   *
   * @type {number}
   * @memberof TypesAppliedSettings
   */
  virtSize?: number;
}

/**
 * Check if a given object implements the TypesAppliedSettings interface.
 */
export function instanceOfTypesAppliedSettings(
  value: object,
): value is TypesAppliedSettings {
  return true;
}

export function TypesAppliedSettingsFromJSON(json: any): TypesAppliedSettings {
  return TypesAppliedSettingsFromJSONTyped(json, false);
}

export function TypesAppliedSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesAppliedSettings {
  if (json == null) {
    return json;
  }
  return {
    diskParameters:
      json['DiskParameters'] == null
        ? undefined
        : V1StorageClassParametersFromJSON(json['DiskParameters']),
    diskSize: json['DiskSize'] == null ? undefined : json['DiskSize'],
    memory: json['Memory'] == null ? undefined : json['Memory'],
    neo4jConfiguration:
      json['Neo4jConfiguration'] == null
        ? undefined
        : json['Neo4jConfiguration'],
    neo4jVersion:
      json['Neo4jVersion'] == null ? undefined : json['Neo4jVersion'],
    virtSize: json['VirtSize'] == null ? undefined : json['VirtSize'],
  };
}

export function TypesAppliedSettingsToJSON(json: any): TypesAppliedSettings {
  return TypesAppliedSettingsToJSONTyped(json, false);
}

export function TypesAppliedSettingsToJSONTyped(
  value?: TypesAppliedSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    DiskParameters: V1StorageClassParametersToJSON(value['diskParameters']),
    DiskSize: value['diskSize'],
    Memory: value['memory'],
    Neo4jConfiguration: value['neo4jConfiguration'],
    Neo4jVersion: value['neo4jVersion'],
    VirtSize: value['virtSize'],
  };
}
